import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../services.module/auth.service';
import { PartnerChangeRequest } from '../../model.module/partner-change.model';

@Component({
    selector: 'print-partneraenderung',
    templateUrl: './partneraenderung.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
// Diese Komponente dient nur fuer die Vertiffung und wird nicht als Druck-Button angezeigt
export class PrintPartnerAenderung {

    @Input()
    model: PartnerChangeRequest = null;

    @Input()
    shown = false;

    @Input()
    invisibleButton = false;

    kundenName = '';

    ordnungsbegriff = '';

    constructor(authService: AuthService) {
        this.kundenName = authService.getActiveKundeOnLogin().nameVn;
        this.ordnungsbegriff = authService.getActiveKunde().vsnr.substring(0, 9);
    }

    notifyOpen(open: boolean): void {
        this.shown = open;
    }

    getDate(): string {
        return new Date().toLocaleString();
    }

}

